<style lang="scss" scoped>
::v-deep textarea {
    min-height: 107px !important;
}
</style>

<template>
    <div class="popup px-16 py-24 p-md-24 p-lg-56" ref="fixBottom">
        <div class="close" @click="$emit('close')"></div>
        <h2 class="mb-40">{{ translations.add_remark_popup.title }}</h2>
        <ValidationObserver v-slot="{ invalid }" tag="div" :slim="true" ref="observer">
            <el-input v-model="remark" class="mb-40" type="textarea" :label="translations.add_remark_popup.remark" rules="" />

            <div class="d-flex mt-40 justify-content-between align-items-center">
                <button type="submit" class="btn btn-accent text-white" :disabled="invalid || success" @click.stop="updateRemark">{{ translations.add_remark_popup.save }}</button>
                <a @click="$emit('close')">{{ translations.add_remark_popup.cancel }}</a>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import core from "../day-configurator-core";
import safariFixedBottom from "../../mixins/safari-fixed-bottom";
var cloneDeep = require('lodash.clonedeep');
import hasForm from '../../mixins/has-form'
import { ValidationObserver, ValidationProvider, validate } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import nl from 'vee-validate/dist/locale/nl.json';
for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: nl.messages[rule]
    });
}

export default {
    mixins: [core, safariFixedBottom, hasForm],

    components: { ValidationObserver, ValidationProvider },

    data: () => ({
        remark: ""
    }),

    props: {
        index: {
            type: Number,
            required: true,
        }
    },

    mounted() {
        this.remark = this.schedule.activities[this.index].data.remarks;
    },

    methods: {
        updateRemark() {
            let activity_object = cloneDeep(this.schedule.activities[this.index]);

            activity_object.data.remarks = this.remark;

            this.$store.dispatch('dayConfigurator/updateActivity', { activity_index: this.index, activity_object: activity_object }).then(() => {
                this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });
                this.$emit('close');
            });
        }
    }
}
</script>